import React, { useState } from 'react'
import './index.css'
import { TeamOutlined, SettingOutlined, GoldOutlined, FundOutlined,ToolOutlined,ShoppingOutlined,SecurityScanOutlined} from '@ant-design/icons';
import { NavLink} from 'react-router-dom';
export default function Menu(props) {
    // 解构props来接收name和age
    const { items } = props;
    const iconMap = {
        customer: TeamOutlined,
        config: SettingOutlined,
        inventory: GoldOutlined,
        statistics: FundOutlined,
        goods: ToolOutlined,
        basket:ShoppingOutlined,
        attribute:SecurityScanOutlined
    };
    function DynamicIcon({ name }) {
        const IconComponent = iconMap[name];; // 通过名称动态获取图标组件
        return IconComponent ? <IconComponent style={{ color: '#fff' }} /> : null; // 确保图标存在
    }
    const [activeId, setActiveId] = useState('customer'); // 存储当前激活的div的索引

    const handleClick = (id) => {
        setActiveId(id); // 设置当前激活的div的索引
    };

    return (
        <div className='menu-item-style'>
            {
                items.map((item, index) => {
                    return <NavLink to={item.menuPath} key={index}><div style={activeId === (item.icon) ?{ backgroundColor: '#fc6c1b' } : {}}  key={index} id={item.icon} onClick={() => handleClick(item.icon)}><DynamicIcon name={item.icon} /> <span style={{ marginLeft: '17px', color: '#fff' }}>{item.menuName}</span></div></NavLink>
                })
            }
        </div>
    )
}